import '@babel/polyfill'
import Vue from 'vue'
import '@/plugins/vuetify'
import '@/plugins/vueProgressiveImage'
import App from './App.vue'
import { router } from './router'
import store from './store'
import '@/backend/vue-axios'
import '@/backend/socket.io'
import './registerServiceWorker'
import VueApollo from 'vue-apollo'
import { apolloClient } from '@/plugins/apollo/apolloUploadClient'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
// import { createProvider } from './vue-apollo'
// import {apolloClient} from '@/plugins/apollo/apolloClient'

Vue.config.productionTip = false

Vue.use(VueApollo)
Vue.use(VueVirtualScroller)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      fetchPolicy: 'cache-and-network'
    }
  },
  errorHandler (error) {
    // eslint-disable-next-line no-console
    console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
      error.message)
  }
})

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
